import { render } from "./MyPagesMenu.vue?vue&type=template&id=d7eb7076"
import script from "./MyPagesMenu.vue?vue&type=script&lang=js"
export * from "./MyPagesMenu.vue?vue&type=script&lang=js"

import "./MyPagesMenu.vue?vue&type=style&index=0&id=d7eb7076&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__